import { Download } from 'lucide-react'
import styles from './PDFExportButton.module.css'

export interface PDFExportButtonProps {
  projectId: string
  onExport?: () => void
  disabled?: boolean
}

export function PDFExportButton({ projectId, onExport, disabled = false }: PDFExportButtonProps) {
  function handleClick() {
    window.open(`/projects/${projectId}/report?print=1`, '_blank')
    onExport?.()
  }

  return (
    <button
      className={styles.btn}
      onClick={disabled ? undefined : handleClick}
      disabled={disabled}
      title={disabled ? 'Analyse noch nicht verfügbar' : 'Als PDF exportieren'}
    >
      <Download size={15} />
      <span>PDF exportieren</span>
    </button>
  )
}
